import * as Sentry from "@sentry/react";

function safeGetStoredUserEmail() {
  try {
    const raw = localStorage.getItem("user");
    if (!raw) return null;
    return JSON.parse(raw)?.email ?? null;
  } catch {
    return null;
  }
}
const DEBUG_EMAIL = "adam.levy@clubchampion.com";

function shouldLogQueryBuilderRw() {
  const email = safeGetStoredUserEmail();
  return email === DEBUG_EMAIL;
}

/**
 * Logs the menu filterString assembled in queryBuilder.
 * Intentionally gated to a single user, Mondays only, rw only.
 */
export function logQueryBuilderFilterString({
  currentDateTerm,
  dateFilterType,
  queryId,
  dateString,
  tab,
} = {}) {
  const isRecentWeeks =
    currentDateTerm === "[Recent Weeks]" || dateFilterType === "rw";

  if (isRecentWeeks && shouldLogQueryBuilderRw()) {
    const now = new Date();
    const nowIso = now.toISOString();
    const weekday = now.getDay();
    const email = safeGetStoredUserEmail();
    const dateStringValue = dateString ?? "";

    const extras = {
      feature: "Recent Weeks",
      action: "Date Filter String",
      currentDateTerm,
      email,
      weekday,
      nowIso,
      dateFilterType,
      queryId: queryId ?? null,
      pageUuid: tab?.uuid ?? null,
      pageDisplayName: tab?.displayName ?? null,
      pageParentName: tab?.parentName ?? null,
      filterStringLength:
        typeof dateStringValue === "string" ? dateStringValue.length : null,
    };

    // Logs product (if enabled in Sentry project).
    Sentry.logger.info(
      `QueryBuilder filterString (rw): ${"Date Filter: " + dateStringValue}`,
      extras
    );
  }
}
